import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { I18nModule, UrlModule } from '@spartacus/core';
import { CartQuickOrderComponent } from './cart-quick-order.component';

@NgModule({
  declarations: [CartQuickOrderComponent],
  imports: [CommonModule, I18nModule, RouterModule, UrlModule],
  exports: [CartQuickOrderComponent],
})
export class CartQuickOrderModule {}
